/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

import Img from "gatsby-image/withIEPolyfill"

import { ab } from "../theme"
import Button from "./button"

const ImageWithTeaserBox = ({
  image,
  imageAlt,
  subHeading,
  heading,
  buttonText,
  link,
  linkTarget,
  download,
  orientation,
  currentLanguage,
  seoLinks,
}) => {
  let getButton = (buttonText, link) => {
    if (buttonText && link) {
      return (
        <Button
          language={currentLanguage}
          seoLinks={seoLinks}
          buttonText={buttonText}
          link={link}
          linkTarget={linkTarget}
          download={download}
          style={{
            float: orientation === "right" ? ab({ md: "right" }) : "none",
          }}
        />
      )
    } else {
      return ""
    }
  }

  return (
    <div sx={{ variant: "spacingContainer" }}>
      <div
        sx={{
          display: ab({ md: "flex" }),
          flexDirection: orientation === "right" ? "row" : "row-reverse",
        }}
      >
        <div
          sx={{
            width: ab({ _: "100%", md: "70%" }),
            overflow: "hidden",
          }}
        >
          <Img fluid={image} alt={imageAlt} />
        </div>
        <div
          sx={{
            width: ab({ md: "40%" }),
            marginRight: orientation === "right" ? 0 : ab({ md: "-10%" }),
            marginLeft: orientation === "right" ? ab({ md: "-10%" }) : 0,
            display: ab({ md: "flex" }),
            flexDirection: "column",
            justifyContent: "center",
            position: "relative",
            zIndex: 2,
          }}
        >
          <div
            sx={{
              flex: 1,
              p: 4,
              display: ab({ _: "none", md: "block" }),
            }}
          ></div>
          <div
            sx={{
              backgroundColor: "primary",
              p: 4,
              color: "#fff",
            }}
          >
            <div
              sx={{
                textTransform: "uppercase",
                letterSpacing: 2,
                fontSize: 2,
              }}
            >
              {subHeading}
            </div>
            <h2
              sx={{
                variant: "styles.h2",
              }}
            >
              {heading}
            </h2>
          </div>
          <div sx={{ flex: 1, p: 4 }}>{getButton(buttonText, link)}</div>
        </div>
      </div>
    </div>
  )
}

ImageWithTeaserBox.propTypes = {
  image: PropTypes.object.isRequired,
  imageAlt: PropTypes.string,
  subHeading: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  link: PropTypes.string,
  linkTarget: PropTypes.string,
  download: PropTypes.bool,
  orientation: PropTypes.oneOf(["right", "left"]).isRequired,
  currentLanguage: PropTypes.oneOf(["", "de", "en"]),
  seoLinks: PropTypes.object,
}

ImageWithTeaserBox.defaultProps = {
  orientation: "left",
  download: false,
  seoLinks: {},
}

export default ImageWithTeaserBox
